import { RenewalSetupStep } from '../RenewalSetup.types';

export const getStepCounter = (steps: RenewalSetupStep[], currentStep: RenewalSetupStep): string => {
  const index = steps.indexOf(currentStep);
  return `${index + 1}/${steps.length}`;
};

export const getStepLabel = (steps: RenewalSetupStep[], currentStep: RenewalSetupStep): string => {
  return `Submit (${getStepCounter(steps, currentStep)})`;
};
